import { TableProps } from 'antd/es/table';
import { AnyObject } from 'antd/es/_util/type';
import { DeleteCell } from '../components/DeleteCell';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestNo',
    ellipsis: true,
  },
  {
    title: 'REQUEST TYPE',
    dataIndex: 'requestTypeId',
    key: 'requestTypeId',
    ellipsis: true,
  },
  {
    title: 'EMPLOYEE',
    dataIndex: 'employee',
    key: 'employee',
    ellipsis: true,
  },
  {
    title: 'COMPANY',
    dataIndex: 'company',
    key: 'company',
    ellipsis: true,
  },
  {
    title: 'DATE & TIME CREATED',
    dataIndex: 'created',
    key: 'created',
    ellipsis: true,
  },
  {
    title: 'LAST UPDATE',
    dataIndex: 'lastUpdated',
    key: 'lastUpdated',
    ellipsis: true,
  },
];

export const getColumns = (
  handleDelete: (record: AnyObject) => void
): TableProps['columns'] => {
  return [
    {
      title: 'NO',
      dataIndex: 'indexNo',
      key: 'indexNo',
    },
    {
      title: 'PR NO',
      dataIndex: 'prID',
      key: 'prID',
    },
    {
      title: 'MATERIAL CODE',
      dataIndex: 'materialCode',
      key: 'materialCode',
    },
    {
      title: 'UNIT',
      dataIndex: 'unitName',
      key: 'unitName',
    },
    {
      title: 'QTY.',
      dataIndex: 'reqQty',
      key: 'reqQty',
    },
    {
      title: 'REMARKS',
      dataIndex: 'comments',
      key: 'comments',
    },
    {
      title: 'ACTION',
      dataIndex: 'action',
      key: 'action',
      width: 80,
      fixed: 'right',
      render: (text, record) => (
        <DeleteCell onClick={() => handleDelete(record)} />
      ),
    },
  ];
};
